import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import add from "../../images/add.svg";
import Frame5001 from "../../images/Frame5001.svg";
import Frame5002 from "../../images/Frame5002.svg";
import { IconBox, ItemBox, StackBox, TitleBox } from "./styles";
import DialogComponent from "../reusableComponents/Dialog";
import AddVehicle from "./AddVehicle";
import { useDispatch, useSelector } from "react-redux";
import { getVehicles, vehicleRemove } from "./vehicleSlice";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { deleteVehicle } from "./httpCalls";
import { Toast } from "../components/Toast";
import VehicleUpdate from "./UpdateVehicle";

function Vehicles() {
  const dispatch = useDispatch();
  const { vehicles } = useSelector((state) => state.vehicle);
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    addModal: false,
    deleteModal: false,
    updateModal: false,
    selected: "",
    idx: null,
  });

  useEffect(() => {
    if (vehicles.length == 0) {
      dispatch(getVehicles());
    }
  }, []);

  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const searchedItems = () => {
    if (state.searchText) {
      const filtered = vehicles.filter((item) =>
        item.driverName.toLowerCase().includes(state.searchText)
      );
      return filtered;
    } else {
      return vehicles;
    }
  };
  const removeToggle = (selected = "", index = null) => {
    setState((prev) => ({
      ...prev,
      deleteModal: !prev.deleteModal,
      idx: index,
      selected,
    }));
  };
  const updateToggle = (selected = "", index = null) => {
    setState((prev) => ({
      ...prev,
      updateModal: !prev.updateModal,
      idx: index,
      selected,
    }));
  };
  const handleDelete = () => {
    try {
      removeToggle();
      if (state.searchText) {
        dispatch(vehicleRemove({ key: "id", val: state.selected._id }));
      } else {
        dispatch(vehicleRemove({ key: "index", val: state.idx }));
      }
      deleteVehicle(state.selected._id, dispatch);
    } catch (err) {
      console.log("err:", err);
      Toast("error", "Error");
    }
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={7.5} md={5} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Vehicles List
            </Typography>
          </Grid>
          <Grid item lg={1.5} xs={4} sx={{ margin: "0 auto" }}>
            <ButtonAdd
              variant="contained"
              fullWidth
              onClick={() => toggle("addModal")}
            >
              Add <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer
        sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
      >
        {searchedItems().map((item, index) => {
          return (
            <ItemBox key={index} container spacing={1} columns={24}>
              <Grid item xs={2}>
                <Typography style={{ color: "#4EAF50" }}>
                  {index + 1}
                </Typography>
              </Grid>
              <Grid item xs={18}>
                <Grid container spacing={0}>
                  <Grid item md={4} xs={12}>
                    <StackBox>
                      <TitleBox>
                        <Typography style={{ color: "#4EAF50" }}>
                          Driver :
                        </Typography>
                        <Typography>{item.driverName}</Typography>
                      </TitleBox>
                      <TitleBox>
                        <Typography style={{ color: "#4EAF50" }}>
                          Vehicle :
                        </Typography>
                        <Typography>{item.vehicleName}</Typography>
                      </TitleBox>
                    </StackBox>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <StackBox>
                      <TitleBox>
                        <Typography style={{ color: "#4EAF50" }}>
                          Vehicle No. :
                        </Typography>
                        <Typography>{item.numberPlate}</Typography>
                      </TitleBox>
                      <TitleBox>
                        <Typography style={{ color: "#4EAF50" }}>
                          Fuel Type :
                        </Typography>
                        <Typography>{item.fuelType}</Typography>
                      </TitleBox>
                    </StackBox>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <StackBox>
                      <TitleBox>
                        <Typography style={{ color: "#4EAF50" }}>
                          Fuel Price :
                        </Typography>
                        <Typography>{item.fuelPrice}</Typography>
                      </TitleBox>
                      <TitleBox>
                        <Typography style={{ color: "#4EAF50" }}>
                          Average/liter :
                        </Typography>
                        <Typography>{item.fuelAverage}</Typography>
                      </TitleBox>
                    </StackBox>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4} height="100%">
                <IconBox>
                  <img
                    style={{ cursor: "pointer" }}
                    src={Frame5001}
                    alt=""
                    onClick={() => updateToggle(item, index)}
                  />
                  <img
                    style={{ cursor: "pointer" }}
                    src={Frame5002}
                    alt=""
                    onClick={() => removeToggle(item, index)}
                  />
                </IconBox>
              </Grid>
            </ItemBox>
          );
        })}
      </BodyContainer>
      <DialogComponent
        title="Add Vehicle"
        open={state.addModal}
        onClose={() => toggle("addModal")}
        dialogContent={<AddVehicle onClose={() => toggle("addModal")} />}
      />
      <DialogComponent
        title="Update Vehicle"
        open={state.updateModal}
        onClose={() => toggle("updateModal")}
        dialogContent={
          <VehicleUpdate data={state} onClose={() => toggle("updateModal")} />
        }
      />
      <DeleteDialog
        title="Delete Vehicle"
        open={state.deleteModal}
        onClose={removeToggle}
        onClickYes={handleDelete}
      />
    </Box>
  );
}

export default Vehicles;
